// extracted by mini-css-extract-plugin
export default {"-large":"Xivlgn_u7QNo97LH9GTg","fontSelectorContainer":"BYqK_qskZMcZNr1iOyzm","divider":"FabBNbVHW3vO9vFuj39A"};